/* eslint-disable no-unused-vars */

import React, { FC, useState } from 'react';
import { CreateEmailerDialog } from './components/CreateEmailerDialog';
import { Button, makeStyles, Typography } from '@material-ui/core';
import { Page } from 'src/components';
import EmailerToolbar from './components/EmailerToolbar';
import { usePermissions } from 'src/hooks';
import EmailerListTable from './components/EmailerListTable';

const useStyles = makeStyles(() => ({
  root: {
    padding: '1em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1em'
  },
  header: { display: 'flex', justifyContent: 'space-between' }
}));

export const EmailerListView: FC = () => {
  const classes = useStyles();
  const { canCreateEmailer } = usePermissions();

  const [isOpenCreateDialog, setIsOpenCreateDialog] = useState<boolean>(false);

  return (
    <Page className={classes.root} title="Emailer">
      <div className={classes.header}>
        <Typography color="textPrimary" gutterBottom variant="h3">
          Emailer
        </Typography>
        {canCreateEmailer ? (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsOpenCreateDialog(true)}
          >
            Create Emailer
          </Button>
        ) : null}
      </div>

      <EmailerToolbar />

      <EmailerListTable />

      {canCreateEmailer ? (
        <CreateEmailerDialog
          open={isOpenCreateDialog}
          onClose={() => setIsOpenCreateDialog(false)}
        />
      ) : null}
    </Page>
  );
};
